module.exports = __webpack_public_path__ + "static/media/Large-01MA030K20DTS_CMJN_.e0d9fb7e.png";